import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { useSelector } from 'react-redux';
import { Avatar, Box, Typography, alpha, useTheme } from '@mui/material';
import { Stars } from '@mui/icons-material';
import { formatCurrency, formatPhone, formatNumber } from '../../../utils/formatters';

const TopByPoints = () => {
  const theme = useTheme();
  const { leaderboards, loading } = useSelector((state) => state.dashboard);

  const columns = [
    {
      field: 'id',
      headerName: '#',
      width: 60,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Box
            sx={{
              width: 32,
              height: 32,
              borderRadius: '50%',
              background:
                params.value <= 3
                  ? `linear-gradient(135deg, #9C27B0 0%, #6A1B9A 100%)`
                  : alpha(theme.palette.secondary.main, 0.1),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 'bold',
              fontSize: '0.875rem',
              color: params.value <= 3 ? 'white' : 'text.primary',
            }}
          >
            {params.value <= 3 ? <Stars sx={{ fontSize: '1.1rem' }} /> : params.value}
          </Box>
        </Box>
      ),
    },
    {
      field: 'phone',
      headerName: 'Player',
      flex: 1, // Allow this column to grow
      minWidth: 160,
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'secondary.main',
              fontSize: '0.875rem',
              fontWeight: 'bold',
            }}
          >
            {params.value.slice(-4)}
          </Avatar>
          <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
            {formatPhone(params.value)}
          </Typography>
        </Box>
      ),
    },
    {
      field: 'points',
      headerName: 'Points',
      width: 110,
      type: 'number',
      renderCell: (params) => (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body2" sx={{ fontWeight: 700, color: 'secondary.main' }}>
            {formatNumber(params.value)}
          </Typography>
          <Stars sx={{ fontSize: '0.875rem', color: 'secondary.main', opacity: 0.7 }} />
        </Box>
      ),
    },
    {
      // --- NEW COLUMN FOR WINNINGS ---
      field: 'win',
      headerName: 'Winnings',
      width: 120,
      type: 'number',
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 700, color: '#4CAF50', fontSize: '0.875rem' }}>
          {formatCurrency(params.value)}
        </Typography>
      ),
    },
    {
      field: 'play',
      headerName: 'Total Play',
      width: 130,
      type: 'number',
      renderCell: (params) => (
        <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
          {formatCurrency(params.value)}
        </Typography>
      ),
    },
  ];

  const top5Rows = leaderboards.topByPoints.slice(0, 5);

  return (
    <DataGrid
      rows={top5Rows}
      columns={columns}
      loading={loading}
      autoHeight
      hideFooter
      disableRowSelectionOnClick
      disableColumnMenu
      getRowId={(row) => row.user_id || row.id}
      sx={{
        border: 'none',
        '& .MuiDataGrid-columnHeaders': {
          bgcolor: alpha(theme.palette.secondary.main, 0.05),
          borderRadius: '12px 12px 0 0',
          fontWeight: 700,
          fontSize: '0.875rem',
          color: 'text.primary',
          borderBottom: `2px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
        },
        '& .MuiDataGrid-columnHeader, & .MuiDataGrid-cell': {
          outline: 'none !important',
          '&:focus': { outline: 'none !important' },
        },
        '& .MuiDataGrid-cell': {
          borderBottom: `1px solid ${theme.palette.divider}`,
        },
        '& .MuiDataGrid-row': {
          transition: 'all 0.2s ease',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: alpha(theme.palette.secondary.main, 0.04),
            transform: 'translateX(4px)',
          },
          '&:last-of-type .MuiDataGrid-cell': {
             borderBottom: 'none',
          },
        },
      }}
    />
  );
};

export default TopByPoints;
// // src/components/dashboard/Leaderboards/TopByPoints.jsx
// import React from 'react';
// import { DataGrid } from '@mui/x-data-grid';
// import { useSelector } from 'react-redux';
// import { Avatar, Box, Typography, Chip, alpha, useTheme } from '@mui/material';
// import { Stars, TrendingUp } from '@mui/icons-material';
// import { formatCurrency, formatPhone, formatNumber } from '../../../utils/formatters';

// const TopByPoints = () => {
//   const theme = useTheme();
//   const { leaderboards, loading } = useSelector((state) => state.dashboard);

//   const columns = [
//     {
//       field: 'rank',
//       headerName: '#',
//       width: 60,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//           <Box
//             sx={{
//               width: 32,
//               height: 32,
//               borderRadius: '50%',
//               background: params.row.id <= 3 
//                 ? `linear-gradient(135deg, #9C27B0 0%, #6A1B9A 100%)`
//                 : alpha(theme.palette.secondary.main, 0.1),
//               display: 'flex',
//               alignItems: 'center',
//               justifyContent: 'center',
//               fontWeight: 'bold',
//               fontSize: '0.875rem',
//               color: params.row.id <= 3 ? 'white' : 'text.primary',
//             }}
//           >
//             {params.row.id <= 3 ? <Stars sx={{ fontSize: '1rem' }} /> : params.row.id}
//           </Box>
//         </Box>
//       ),
//     },
//     {
//       field: 'phone',
//       headerName: 'Player',
//       width: 160,
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
//           <Avatar
//             sx={{
//               width: 32,
//               height: 32,
//               bgcolor: 'secondary.main',
//               fontSize: '0.875rem',
//               fontWeight: 'bold',
//             }}
//           >
//             {params.value.slice(-4)}
//           </Avatar>
//           <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.875rem' }}>
//             {formatPhone(params.value)}
//           </Typography>
//         </Box>
//       ),
//     },
//     {
//       field: 'points',
//       headerName: 'Points',
//       width: 120,
//       type: 'number',
//       renderCell: (params) => (
//         <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
//           <Typography variant="body2" sx={{ fontWeight: 700, color: '#9C27B0' }}>
//             {formatNumber(params.value)}
//           </Typography>
//           <Stars sx={{ fontSize: '0.875rem', color: '#9C27B0' }} />
//         </Box>
//       ),
//     },
//     {
//       field: 'play',
//       headerName: 'Total Play',
//       width: 130,
//       type: 'number',
//       renderCell: (params) => (
//         <Typography variant="body2" sx={{ fontWeight: 600, color: 'text.secondary' }}>
//           {formatCurrency(params.value)}
//         </Typography>
//       ),
//     },
//   ];

//   const rowsWithRank = leaderboards.topByPoints.map((row, index) => ({
//     ...row,
//     rank: index + 1,
//   }));

//   return (
//     <DataGrid
//       rows={rowsWithRank}
//       columns={columns}
//       loading={loading}
//       autoHeight
//       hideFooter
//       disableRowSelectionOnClick
//       disableColumnMenu
//       sx={{
//         border: 'none',
//         '& .MuiDataGrid-columnHeaders': {
//           bgcolor: alpha(theme.palette.secondary.main, 0.05),
//           borderRadius: '12px 12px 0 0',
//           fontWeight: 700,
//           fontSize: '0.875rem',
//           color: 'text.primary',
//           borderBottom: `2px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
//         },
//         '& .MuiDataGrid-columnHeader': {
//           outline: 'none',
//           '&:focus': { outline: 'none' },
//         },
//         '& .MuiDataGrid-cell': {
//           borderBottom: `1px solid ${alpha(theme.palette.divider, 0.5)}`,
//           outline: 'none',
//           '&:focus': { outline: 'none' },
//         },
//         '& .MuiDataGrid-row': {
//           transition: 'all 0.2s ease',
//           cursor: 'pointer',
//           '&:hover': {
//             bgcolor: alpha(theme.palette.secondary.main, 0.04),
//             transform: 'translateX(4px)',
//           },
//           '&:nth-of-type(odd)': {
//             bgcolor: alpha(theme.palette.grey[100], theme.palette.mode === 'dark' ? 0.02 : 0.3),
//           },
//         },
//       }}
//     />
//   );
// };

// export default TopByPoints;
